import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import './column-pill.scss';

class ColumnPill extends PureComponent {
  handleCloseClick = () => this.props.onClose(this.props.label);

  render() {
    return (
      <div className={`glu-pill column-pill ${this.props.columnClass}`}>
        <span>{this.props.label}</span>
        {this.props.closable && (
          <span className="g-icon g-icon-close column-close" onClick={this.handleCloseClick} />
        )}
      </div>
    );
  }
}

ColumnPill.propTypes = {
  label: PropTypes.string,
  closable: PropTypes.bool,
  onClose: PropTypes.func,
  columnClass: PropTypes.string.isRequired,
};

ColumnPill.defaultProps = {
  label: null,
  closable: false,
  onClose: null,
};

export default ColumnPill;
